import React from 'react';

function About() {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">About Us</h2>
          <div className="title-underline"></div>
        </div>
        <div className="about-content">
          <div className="about-text">
            <p className="highlight-text">
              수많은 프로젝트를 수행하며 우리는 한 가지 질문을 반복해 왔습니다. 
              <strong>"왜 같은 문제는 계속해서 반복되는가?"</strong>
            </p>
            
            <p>
              현장에서 마주한 문제는 결코 단편적인 원인으로 발생하지 않았습니다. 사람의 문제처럼 보였지만 업무의 문제였고,<br/>
              업무의 문제처럼 보였지만 프로세스의 문제였습니다.
            </p>
            
            <p>프로세스의 균열은 조직의 비효율로 이어졌고, 결국 전략의 실행력 약화로 이어졌습니다.</p>
            
            <div className="key-message">
              <h3>유니원솔루션은 문제를 단편적으로 바라보지 않습니다.</h3>
              <p>사람(People), 업무(Work), 프로세스(Process), 조직(Organization), 전략(Strategy)을 하나의 유기적인 흐름으로 이해하고 문제의 본질을 탐구합니다.</p>
            </div>

            <div className="approach-framework">
              <div className="framework-item">People</div>
              <div className="framework-arrow">→</div>
              <div className="framework-item">Work</div>
              <div className="framework-arrow">→</div>
              <div className="framework-item">Process</div>
              <div className="framework-arrow">→</div>
              <div className="framework-item">Organization</div>
              <div className="framework-arrow">→</div>
              <div className="framework-item">Strategy</div>
            </div>

            <p className="closing-statement">
              우리는 서로 연결된 요소를 통합적으로 분석하여<br/>
              <strong>현장에서 실제로 작동하는 실행 가능한 방향을 설계합니다.</strong>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
